module.exports = __webpack_public_path__ + "static/img/zero.ddf892a7.png";